import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const FeedbackIcon: React.FC<IconProps> = ({ color = "#fd6a65" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g fill={color}>
          <path
            d="M6.75 12.55c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C9.03 7.75 9.87 7.75 11.55 7.75h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311c.327.642.327 1.482.327 3.162v11.2l-2.649-1.324c-.504-.252-.756-.378-1.02-.467a4.001 4.001 0 0 0-.72-.17c-.277-.039-.558-.039-1.122-.039H11.55c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-4.4Z"
            fillRule="nonzero"
            opacity=".12"
          />
          <path d="M11.518 7h8.464c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2V23.75a.75.75 0 0 1-1.085.67l-2.65-1.323c-.521-.261-.72-.359-.923-.427a3.255 3.255 0 0 0-.586-.139c-.212-.03-.433-.031-1.017-.031h-7.721c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.638c-.226-.445-.32-.925-.365-1.471C6 18.45 6 17.795 6 16.982v-4.464c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365C10.05 7 10.706 7 11.519 7ZM9.64 8.538c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v4.4c0 .853 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h7.742c.513 0 .844 0 1.172.046.291.04.578.108.856.202.315.106.61.254 1.07.483l.047.024 1.563.782V12.55c0-.852 0-1.447-.038-1.91-.037-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.983-.984c-.198-.1-.459-.17-.913-.207-.462-.037-1.056-.038-1.909-.038h-8.4c-.852 0-1.447 0-1.91.038ZM10 11.75a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75Zm.75 3.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Z" />
        </g>
      </g>
    </svg>
  );
};
